const INGREDIENT_MAIN_KEYWORDS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  initialData: {
    synonyms: [],
    varieties: [],
    uncategorized: [],
    discarded: [],
  },
  data: {
    synonyms: [],
    varieties: [],
    uncategorized: [],
    discarded: [],
  },
  isDirty: false,
  dataForRenaming: undefined,
  checkedKeywordKeys: {
    synonyms: [],
    varieties: [],
    uncategorized: [],
    discarded: [],
  },
}

export default INGREDIENT_MAIN_KEYWORDS_INITIAL_STATE
